import React from "react";

export default function Marquee({ text = "EXTREME OFFSET RIMS • UNCOMPROMISED PERFORMANCE •", stroke = true }) {
  const content = `${text} `.repeat(4);
  return (
    <div className="relative overflow-hidden py-6 border-y border-[#27272a] bg-[#050505]">
      <div className="flex whitespace-nowrap animate-marquee">
        <span className={`font-display text-6xl md:text-8xl leading-none pr-8 ${stroke ? "text-stroke" : "bttf-text"}`}>
          {content}
        </span>
        <span className={`font-display text-6xl md:text-8xl leading-none pr-8 ${stroke ? "text-stroke" : "bttf-text"}`} aria-hidden>
          {content}
        </span>
      </div>
    </div>
  );
}
